export default "__VITE_ASSET__DRW$Mjx6__$_?nuxt_component=async&nuxt_component_name=IconPaymentPaypal&nuxt_component_export=default__"